import type { ReactNode } from "react";

import { CookieBanner } from "@/components/site/CookieBanner";
import { EnFooter } from "./EnFooter";
import { EnHeader } from "./EnHeader";

export function EnLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <EnHeader />
      <main id="main-content" className="flex-1">{children}</main>
      <EnFooter />
      <CookieBanner />
    </div>
  );
}
